/* Products-Scroll: markiert im Mobile-Karussell die Card am nächsten zum
   horizontalen Container-Mittelpunkt mit `.is-active`. Hover-State auf
   Mobile ist via @media (hover: hover) im CSS ausgeschaltet — diese
   Klasse triggert stattdessen den Shadow.

   Warum nicht IntersectionObserver: IO triggert nur bei Threshold-Wechsel,
   nicht kontinuierlich beim Center-Wechsel. Da wir den genauen Mittelpunkt
   wissen wollen (welche Card am dichtesten am Container-Center liegt),
   ist ein rAF-throttled scroll-Listener präziser. Wenig Overhead, da
   nur auf Mobile aktiv. */
(function () {
  'use strict';

  if (!('querySelectorAll' in document)) return;

  var MOBILE_BREAKPOINT = 900;
  var mql = window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)');

  /** Findet die Card, deren horizontaler Mittelpunkt am dichtesten am
   *  Container-Mittelpunkt liegt. Setzt .is-active dort, entfernt auf den
   *  anderen Cards des gleichen Containers. */
  function updateActive(scroller) {
    var cards = scroller.children;
    if (!cards.length) return;
    var rect = scroller.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var bestIdx = 0;
    var bestDist = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var cr = c.getBoundingClientRect();
      var cMid = cr.left + cr.width / 2;
      var d = Math.abs(cMid - centerX);
      if (d < bestDist) {
        bestDist = d;
        bestIdx = i;
      }
    }
    for (var j = 0; j < cards.length; j++) {
      if (j === bestIdx) cards[j].classList.add('is-active');
      else cards[j].classList.remove('is-active');
    }
  }

  function clearActive(scroller) {
    var cards = scroller.children;
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove('is-active');
    }
  }

  function bindScroller(scroller) {
    var rafId = 0;
    function onScroll() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = 0;
        updateActive(scroller);
      });
    }
    scroller.addEventListener('scroll', onScroll, { passive: true });
    // Bei Resize neu berechnen (z.B. Geräte-Rotation).
    window.addEventListener('resize', onScroll);
    // Initial-State setzen, sobald mobile-MQ greift.
    updateActive(scroller);
  }

  function init() {
    var scrollers = document.querySelectorAll('.products-scroll--mobile');
    if (!scrollers.length) return;
    for (var i = 0; i < scrollers.length; i++) {
      if (scrollers[i].dataset.scrollActiveBound === '1') continue;
      scrollers[i].dataset.scrollActiveBound = '1';
      if (mql.matches) {
        bindScroller(scrollers[i]);
      } else {
        // Desktop: keine Active-Klasse nötig (Hover greift via CSS).
        clearActive(scrollers[i]);
      }
    }
  }

  // MQ-Wechsel (Viewport-Resize über Breakpoint): Active-State entweder
  // setzen oder entfernen.
  function onMqChange() {
    var scrollers = document.querySelectorAll('.products-scroll--mobile');
    for (var i = 0; i < scrollers.length; i++) {
      if (mql.matches) {
        updateActive(scrollers[i]);
      } else {
        clearActive(scrollers[i]);
      }
    }
  }
  if (mql.addEventListener) mql.addEventListener('change', onMqChange);
  else if (mql.addListener) mql.addListener(onMqChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
